






















































































































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import PxDropdown from "@/views/components/input/formFields/PxDropdown.vue";
import PxNumberInput from "@/views/components/input/formFields/PxNumberInput.vue";
import ProbabilisticChart from "@/modules/lcca/views/components/ProbablisticChart.vue";
import PxTextArea from "@/views/components/input/formFields/PxTextArea.vue";
import PxTextEntryBox from "@/views/components/input/formFields/PxTextEntryBox.vue";
import QuickHelp from "@/views/components/input/QuickHelp.vue";
import {UnitSystem} from "@/interfaces/units";
import {ImperialUnits, MetricUnits} from "@/lib/unitConversion/unitConversionFactors";
import {
  IAgencyCostActivityImperial,
  IAgencyCostActivityMetric,
  IAgencyCostImperial,
  IAgencyCostLineItemImperial,
  IAgencyCostLineItemMetric,
  IAgencyCostMetric,
  LineItemTypes,
  MainlineOptions
} from "@/modules/agencyCost/interfaces/agencyCost";
import {defaultLineItems} from "@/modules/agencyCost/lib/unitCostsAndMeasures";
import {
  getLineItemCost,
  getLineItemNpv,
  getQuantityImperial,
  getQuantityMetric
} from "@/modules/agencyCost/lib/calculations/lineItem";
import AgencyCostPlot from "@/modules/agencyCost/views/components/AgencyCostPlot.vue";
import {agencyStore} from "@/store/store";

@Component({
  components: {
    AgencyCostPlot,
    QuickHelp,
    PxTextEntryBox,
    PxTextArea,
    ProbabilisticChart,
    PxDropdown,
    PxNumberInput
  },
})
export default class AgencyCostActivityEditor extends Vue {
  @Prop() scenario!: IAgencyCostImperial | IAgencyCostMetric;
  @Prop() scenarioImperial!: IAgencyCostImperial;
  @Prop() activity!: IAgencyCostActivityImperial | IAgencyCostActivityMetric;
  @Prop() activityImperial!: IAgencyCostActivityImperial;
  @Prop({default: null}) validations!: any;
  @Prop() index!: number;

  // @PropSync('alternative') alt!: ILccaAlternative;

  get isImperial() {
    return this.activity.unitSystem === UnitSystem.Imperial
  }

  get imperialUnits() {
    return ImperialUnits
  }

  get metricUnits() {
    return MetricUnits
  }

  calcAllNpvs(lineItems: IAgencyCostLineItemImperial[]) {
    const npvs = lineItems.map((item) => this.lineItemNpvFcn(item, this.scenario.discountRate_pct || 0, this.activity.yearsAfterStart))

    return npvs.reduce((a, b) => a + b, 0)
  }

  calcCostSum(lineItems: IAgencyCostLineItemImperial[]) {
    const cost = lineItems.map((item) => this.lineItemCostFcn(item))

    return Number(cost.reduce((a, b) => a + b, 0).toFixed(0))
  }

  sync() {
    /*
    Iterate through each activity and line item and calculate their quantities
    */
    this.scenario.activities.forEach((A: any) => {

      if (A.unitSystem === UnitSystem.Imperial) {
        A.lineItems.forEach((L: IAgencyCostLineItemImperial) => {
          L.quantity = getQuantityImperial(L, <IAgencyCostImperial>this.scenario)
        })
      } else {
        A.lineItems.forEach((L: IAgencyCostLineItemMetric) => {
          L.quantity = getQuantityMetric(L, <IAgencyCostMetric>this.scenario)
        })
      }
    });

    this.$emit('sync');
  }

  /*
  Add line item system
   */

  selectedHardCostLineItem: IAgencyCostLineItemImperial[] = [];
  selectedOperationLineItem: IAgencyCostLineItemImperial[] = [];

  availableHardCosts: IAgencyCostLineItemImperial[] = [];

  availableOperations: IAgencyCostLineItemImperial[] = [];

  loadLineItems() {
    this.availableHardCosts = [];
    this.availableOperations = [];
    const basicHardCosts = defaultLineItems.filter((item) => item.type === LineItemTypes.HARDCOST);
    const basicOperations = defaultLineItems.filter((item) => item.type === LineItemTypes.OPERATION);

    agencyStore.loadLineItemDefaults().then((items: IAgencyCostLineItemImperial[]) => {
      const hardCosts = items.filter((item) => item.type === LineItemTypes.HARDCOST);
      this.availableHardCosts.push(...hardCosts);
      this.availableHardCosts.push(...basicHardCosts);

      const operations = items.filter((item) => item.type === LineItemTypes.OPERATION);
      this.availableOperations.push(...operations);
      this.availableOperations.push(...basicOperations);
    });
  }

  lineItemFields = [
    {key: 'mainline', label: 'Width'},
    {key: 'name', label: 'Name'},
    {key: 'thickness', label: 'Thickness'},
    {key: 'quantity', label: 'Quantity'},
    {key: 'unitCost', label: 'Unit Cost'},
    {key: 'subtotal', label: 'Total'},
    {key: 'npv', label: 'NPV'},
    {key: 'actions', label: ''},
  ];

  get lineItemHardCostOptions() {
    return this.availableHardCosts.map(L => {
      return {text: L.name, value: L}
    }).filter(L => L !== undefined);
  }

  get lineItemOperationOptions() {
    return this.availableOperations.map(L => {
      return {text: L.name, value: L}
    }).filter(L => L !== undefined);
  }

  addLineItem() {
    this.selectedHardCostLineItem.forEach(L => {
      const itemCopy = JSON.parse(JSON.stringify(L));
      itemCopy.isDefault = false;
      itemCopy.id = null;
      this.activityImperial.lineItems.push(itemCopy)
    });

    this.selectedOperationLineItem.forEach(L => {
      const itemCopy = JSON.parse(JSON.stringify(L));
      itemCopy.isDefault = false;
      itemCopy.id = null;
      this.activityImperial.lineItems.push(itemCopy)
    });

    this.selectedHardCostLineItem = [];
    this.selectedOperationLineItem = [];
  }

  get lineItemCostFcn() {
    return getLineItemCost
  }

  get lineItemNpvFcn() {
    return getLineItemNpv
  }


  get unitOptions() {
    if (this.isImperial) {
      return Object.values(ImperialUnits).map(U => {
        return {value: U, text: U}
      })
    } else {
      return Object.values(MetricUnits).map(U => {
        return {value: U, text: U}
      })
    }
  }

  get mainlineOptions() {
    return Object.values(MainlineOptions).map(v => {
      return {text: v, value: v}
    })
  }

  newLineItem() {
    this.activity.lineItems.push({
      // @ts-ignore
      id: -1,
      // @ts-ignore
      units: null,
      // @ts-ignore
      quantity: 0,
      // @ts-ignore
      unitDescr: null,
      // @ts-ignore
      unitCost: 0,
      // @ts-ignore
      name: "",
      //@ts-ignore
      unitSystem: this.activity.unitSystem
    })
  }

  deleteLineItem(item: IAgencyCostLineItemMetric | IAgencyCostLineItemImperial) {
    // @ts-ignore
    this.activity.lineItems = this.activity.lineItems.filter((x) => x !== item);
    this.sync();
  }

  deleteActivity() {
    this.scenarioImperial.activities = this.scenarioImperial.activities.filter(A => A !== this.activityImperial)
    this.sync();
  }

  copyActivity() {
    console.log('copying', this.activityImperial.id)
    const newActivity = JSON.parse(JSON.stringify(this.activityImperial));
    newActivity.id = null;
    this.scenarioImperial.activities.push(newActivity);
    this.sync()
  }

  fields = [
    {key: 'name', label: 'Name'},
    {key: 'units', label: 'Units'},
    {key: 'quantity', label: 'Quantity'},
    {key: 'unitCost', label: 'Unit Cost'},
    {key: 'subtotal', label: 'Sub-Total'}
  ]

  mounted() {
    this.loadLineItems()
  }
}


